export default __webpack_public_path__ + "static/media/no-data.ffdad94d.svg";